import { defineMessages, FormattedMessage } from 'react-intl';

import { getLinkAriaLabel } from '@/utils/urlUtils';

import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import { Text } from '@/components/Text';
import { getBrandConfig } from '@/lib/configuration/configuration';
import { paths } from '@/lib/paths';

import { commonMessages } from './common';

const intlPrefix = 'forms';

export const formMessages = defineMessages({
  apartmentNumber: {
    defaultMessage: 'Apartment number',
    id: `${intlPrefix}.apartmentNumber`,
  },
  houseMansionName: {
    defaultMessage: 'House/Mansion Name',
    id: `${intlPrefix}.houseMansionName`,
  },
  title: {
    defaultMessage: 'Title',
    id: `${intlPrefix}.title`,
  },
  male: {
    defaultMessage: 'Male',
    id: `${intlPrefix}.male`,
  },
  female: {
    defaultMessage: 'Female',
    id: `${intlPrefix}.female`,
  },
  none: {
    defaultMessage: 'None',
    id: `${intlPrefix}.none`,
  },
  preferNotToSay: {
    defaultMessage: 'Prefer not to say',
    id: `${intlPrefix}.preferNotToSay`,
  },
  mr: {
    defaultMessage: 'Mr',
    id: `checkout.delivery.shippingAddress.title.mr`,
  },
  mrs: {
    defaultMessage: 'Mrs',
    id: `checkout.delivery.shippingAddress.title.mrs`,
  },
  ms: {
    defaultMessage: 'Ms',
    id: `checkout.delivery.shippingAddress.title.ms`,
  },
  firstName: {
    defaultMessage: 'First name',
    id: `checkout.delivery.shippingAddress.firstname`,
  },
  lastName: {
    defaultMessage: 'Last name',
    id: `checkout.delivery.shippingAddress.lastname`,
  },
  invalidEmailAddress: {
    defaultMessage: 'Invalid email address.',
    id: `${intlPrefix}.invalidEmailAddress`,
  },
  invalidPhoneNumber: {
    defaultMessage: 'Invalid phone number.',
    id: `${intlPrefix}.invalidPhoneNumber`,
  },
  technicalError: {
    defaultMessage: 'A technical error has occurred',
    id: 'form.technicalError',
  },
  optional: {
    defaultMessage: 'Optional',
    id: `${intlPrefix}.optional`,
  },
  requiredField: {
    defaultMessage: 'This field is required.',
    id: `${intlPrefix}.requiredField`,
  },
  invalidField: {
    defaultMessage: 'This field is invalid.',
    id: `${intlPrefix}.invalidField`,
  },
  incorrectBirthDateField: {
    defaultMessage: 'Birthdate is incorrect.',
    id: `${intlPrefix}.incorrectBirthDateField`,
  },
  incorrectBirthDateFieldUnder18: {
    defaultMessage: 'You must be at least 18 years old to proceed',
    id: `${intlPrefix}.birthDateFieldAtLeastEighteen`,
  },
  inputErrorMustBeValidEmail: {
    defaultMessage: 'email must be a valid email',
    id: `${intlPrefix}.inputErrorMustBeValidEmail`,
  },
  maxChars: {
    defaultMessage: '{max} characters maximum.',
    id: `${intlPrefix}.maxChars`,
  },
  minChars: {
    defaultMessage: '{min} characters minimum.',
    id: `${intlPrefix}.minChars`,
  },
  passwordsMustMatch: {
    defaultMessage: 'Passwords must match.',
    id: `${intlPrefix}.passwordsMustMatch`,
  },
  email: {
    defaultMessage: 'E-mail',
    id: `checkout.delivery.contact.email`,
  },
  emailAddress: {
    defaultMessage: 'Email address',
    id: `account.login.email`,
  },
  telephoneNumber: {
    defaultMessage: 'Telephone number',
    id: `checkout.delivery.contact.phone`,
  },
  mobile: {
    defaultMessage: 'Mobile',
    id: `${intlPrefix}.mobile`,
  },
  password: {
    defaultMessage: 'Password',
    id: `account.login.password`,
  },
  passwordConfirm: {
    defaultMessage: 'Password confirm',
    id: `${intlPrefix}.passwordConfirm`,
  },
  passwordMustContain: {
    defaultMessage:
      'Password must contain 10 characters, uppercase character, lowercase character, number and special character',
    id: `${intlPrefix}.passwordMustContain`,
  },
  mandatoryFields: {
    defaultMessage: '*Mandatory fields',
    id: `checkout.delivery.shippingAddress.mandatory`,
  },
  company: {
    defaultMessage: 'Company',
    id: `checkout.delivery.shippingAddress.company`,
  },
  vatNumber: {
    defaultMessage: 'VAT number',
    id: `${intlPrefix}.vatNumber`,
  },
  abn: {
    defaultMessage: 'ABN (Mandatory if company name is provided)',
    id: `${intlPrefix}.abn`,
  },
  streetName: {
    defaultMessage: 'Street name',
    id: `${intlPrefix}.streetName`,
  },
  streetNumber: {
    defaultMessage: 'Street number',
    id: `${intlPrefix}.streetNumber`,
  },
  apartmentSuiteFloor: {
    defaultMessage: 'APT / STE / FL',
    id: `checkout.delivery.shippingAddress.floor`,
  },
  chomeBanchiBango: {
    defaultMessage: 'Chome Banchi Bango',
    id: `checkout.delivery.chomeBanchiBango`,
  },
  cityWardTown: {
    defaultMessage: 'City/Ward/Town',
    id: `checkout.delivery.cityWardTown`,
  },
  placeholderOptional: {
    defaultMessage: 'Optional',
    id: `${intlPrefix}.optional`,
  },
  postalCode: {
    defaultMessage: 'Postal code',
    id: `${intlPrefix}.postalCode`,
  },
  countryArea: {
    defaultMessage: 'Country area',
    id: `${intlPrefix}.countryArea`,
  },
  city: {
    defaultMessage: 'City',
    id: `checkout.delivery.shippingAddress.city`,
  },
  message: {
    defaultMessage: 'Message',
    id: `${intlPrefix}.message`,
  },
  personalData: {
    defaultMessage: 'Personal Data',
    id: `${intlPrefix}.personalData`,
  },
  language: {
    defaultMessage: 'Language',
    id: `${intlPrefix}.language`,
  },
  country: {
    defaultMessage: 'Country',
    id: `${intlPrefix}.country`,
  },
  phone: {
    defaultMessage: 'Phone',
    id: `${intlPrefix}.phone`,
  },
  name: {
    defaultMessage: 'Name',
    id: `${intlPrefix}.name`,
  },
  birthDate: {
    defaultMessage: 'Birthdate',
    id: `${intlPrefix}.birthDate`,
  },
  dateOfBirth: {
    defaultMessage: 'Date of birth',
    id: `${intlPrefix}.dateOfBirth`,
  },
  boutique: {
    defaultMessage: 'Boutique',
    id: `checkout.delivery.boutique.name`,
  },
  findYourClosestBoutique: {
    defaultMessage: 'Find Your Boutique',
    id: `checkout.delivery.findClosestBoutique`,
  },
  findYourAddress: {
    defaultMessage: 'Find your address',
    id: `${intlPrefix}.findYourAddress`,
  },
  unableToShipToPO: {
    defaultMessage: 'We are unable to ship to P.O Boxes',
    id: `${intlPrefix}.unableToShipToPO`,
  },
  cityStreet: {
    defaultMessage: 'City / Street',
    id: `${intlPrefix}.cityStreet`,
  },
  boutiqueHours: {
    defaultMessage: 'Boutique opening hours',
    id: `${intlPrefix}.boutiqueHours`,
  },
  seeMore: {
    defaultMessage: 'See More',
    id: `${intlPrefix}.seeMore`,
  },
  wednesday: {
    defaultMessage: 'Wednesday',
    id: `${intlPrefix}.wednesday`,
  },
  thursday: {
    defaultMessage: 'Thursday',
    id: `${intlPrefix}.thursday`,
  },
  friday: {
    defaultMessage: 'Friday',
    id: `${intlPrefix}.friday`,
  },
  saturday: {
    defaultMessage: 'Saturday',
    id: `${intlPrefix}.saturday`,
  },
  sunday: {
    defaultMessage: 'Sunday',
    id: `${intlPrefix}.sunday`,
  },
  monday: {
    defaultMessage: 'Monday',
    id: `${intlPrefix}.monday`,
  },
  tuesday: {
    defaultMessage: 'Tuesday',
    id: `${intlPrefix}.tuesday`,
  },
  address: {
    defaultMessage: 'Address',
    id: `checkout.delivery.shippingAddress.address`,
  },
  whitespaceOnly: {
    defaultMessage: 'Field must not contain white spaces',
    id: 'filedOnlyWhiteSpaces',
  },
  invalidPhone: {
    defaultMessage: 'Phone number not valid',
    id: 'invalidPhoneNumber',
  },
  noAdjustment: {
    defaultMessage: 'No adjustment',
    id: 'forms.noAdjustment',
  },
  invalidNameNoSpecialCharacters: {
    defaultMessage: 'Can only contain letters, digits, spaces and hyphens(-)',
    id: `${intlPrefix}.invalidName.noSpecialCharacters`,
  },
  invalidNameNoConsecutiveSpacesOrHyphens: {
    defaultMessage: 'Cannot contain consecutive spaces or hyphens',
    id: `${intlPrefix}.invalidName.noConsecutiveSpacesOrHyphens`,
  },
  invalidNameTextWithDelimiterRegex: {
    defaultMessage: 'Spaces or hyphens must appear between letters or numbers.',
    id: `${intlPrefix}.invalidName.TextWithDelimiter`,
  },
  invalidNameTrimmedDelimiterRegex: {
    defaultMessage: 'String cannot start or end with a space or hyphen.',
    id: `${intlPrefix}.invalidName.TrimmedDelimiter`,
  },

  createMyAccount: {
    defaultMessage: 'Create my account',
    id: `${intlPrefix}.createMyAccount`,
  },
  registerMyWatch: {
    defaultMessage: 'Register my watch',
    id: `${intlPrefix}.registerMyWatch`,
  },
  newsletterConsent: {
    defaultMessage:
      'I would like to be kept informed by Breitling SA and my preferred Boutique about Breitling offers, events, and other customer engagement activities through email, telephone, SMS, post, and WhatsApp.',
    id: `${intlPrefix}.checkbox.newsletterConsent`,
  },
  archivesInvalidUpload: {
    defaultMessage: 'Please upload watch pictures',
    id: `${intlPrefix}.archivesInvalidUpload`,
  },
  archivesInvalidUploadLimit: {
    defaultMessage: 'Uploading up to two images',
    id: `${intlPrefix}.archivesInvalidUploadLimit`,
  },
  archivesInvalidUploadTypeLimit: {
    defaultMessage: ` has an invalid file format. Only JPG, JPEG, PNG, and WEBP formats are allowed.`,
    id: `${intlPrefix}.archivesInvalidUploadTypeLimit`,
  },
  archivesInvalidUploadSizeLimit: {
    defaultMessage: ` exceeds the 2MB size limit.`,
    id: `${intlPrefix}.archivesInvalidUploadSizeLimit`,
  },
  firstNameKanji: {
    defaultMessage: 'First name (Kanji)',
    id: `checkout.delivery.shippingAddress.firstNameKanji`,
  },
  lastNameKanji: {
    defaultMessage: 'Last name (Kanji)',
    id: `checkout.delivery.shippingAddress.lastNameKanji`,
  },
  firstNameKatakana: {
    defaultMessage: 'First name (Katakana)',
    id: `checkout.delivery.shippingAddress.firstNameKatakana`,
  },
  lastNameKatakana: {
    defaultMessage: 'Last name (Katakana)',
    id: `checkout.delivery.shippingAddress.lastNameKatakana`,
  },
  joinBreitlingClub: {
    defaultMessage: 'I would like to join Breitling Club',
    id: `${intlPrefix}.joinBreitlingClub`,
  },
  receiveReceipt: {
    defaultMessage: 'I want a receipt to be issued',
    id: `${intlPrefix}.receiveReceipt`,
  },
  firstNameForJP: {
    defaultMessage: 'First name',
    id: `checkout.delivery.shippingAddress.firstNameForJP`,
  },
  lastNameForJP: {
    defaultMessage: 'Last name',
    id: `checkout.delivery.shippingAddress.lastNameForJP`,
  },
  notSupportedAddress: {
    defaultMessage:
      'We are currently unable to deliver to this area. Please choose another delivery destination or contact our customer relationship squad.',
    id: `${intlPrefix}.notSupportedAddress`,
  },
});

export const RevokeConsent = (
  <FormattedMessage
    defaultMessage='You can revoke this consent at any time by sending a message to {dataPrivacyEmail} or by clicking the “unsubscribe” button in our marketing emails.'
    id={`${intlPrefix}.revokeConsent`}
    values={{
      dataPrivacyEmail: (
        <LinkWithLocale
          href={`mailto: ${getBrandConfig().dataPrivacyEmail}`}
          rel='noreferrer'
          target='_blank'
        >
          {getBrandConfig().dataPrivacyEmail}
        </LinkWithLocale>
      ),
    }}
  />
);

export const PersonalDataPolicy = (
  <FormattedMessage
    defaultMessage='Breitling SA will handle your Personal Data in accordance with all applicable Data Protection regulations and {policyLink}. As a Breitling customer, you are entitled to certain rights based on the General Data Protection Regulation (GDPR). For further information, please see {gdprLink}.'
    id='placeholder.paymentMethod.privacyDescription'
    values={{
      policyLink: (
        <LinkWithLocale
          aria-label={getLinkAriaLabel(
            paths.privacyPolicy.url().pathname ?? '',
          )}
          href={paths.privacyPolicy.url()}
          target='_blank'
        >
          <FormattedMessage {...commonMessages.breitlingPrivacyPolicy} />
        </LinkWithLocale>
      ),
      gdprLink: (
        <LinkWithLocale
          aria-label={getLinkAriaLabel(paths.gdpr.url().pathname ?? '')}
          href={paths.gdpr.url()}
          target='_blank'
        >
          <FormattedMessage {...commonMessages.here} />
        </LinkWithLocale>
      ),
    }}
  />
);

export const AccountCreationConfirmationNote = (
  action: string,
  termsOfUse: string,
) => (
  <FormattedMessage
    defaultMessage={`By clicking "{action}", you confirm you have read the { policyLink } and have read and accepted { termsOfUseLink }.`}
    id={`${intlPrefix}.accountCreationConfirmationNote`}
    values={{
      policyLink: (
        <LinkWithLocale
          aria-label={getLinkAriaLabel(
            paths.privacyPolicy.url().pathname ?? '',
          )}
          href={paths.privacyPolicy.url()}
          target='_blank'
        >
          <FormattedMessage {...commonMessages.breitlingPrivacyPolicy} />
        </LinkWithLocale>
      ),
      termsOfUseLink: (
        <LinkWithLocale
          aria-label={getLinkAriaLabel(paths.termsOfUse.url().pathname ?? '')}
          href={paths.termsOfUse.url()}
          target='_blank'
        >
          {termsOfUse}
        </LinkWithLocale>
      ),
      action,
    }}
  />
);

export const RegisterMyWatchCheckboxMsg = (isAuthenticated: boolean) => (
  <FormattedMessage
    defaultMessage={
      isAuthenticated
        ? 'I would like to register my watch'
        : 'I would like to create My Account and Register My Watch'
    }
    id={`${intlPrefix}.registerMyWatchCheckboxMsg`}
  />
);
export const RegisterMyWatchCheckboxAuthMessage = () => (
  <FormattedMessage
    defaultMessage='I would like to register my watch'
    id='checkout.paymentMethod.registerCheckbox'
  />
);
export const RegisterMyWatchCheckboxUnAuthMessage = () => (
  <FormattedMessage
    defaultMessage='I would like to create My Account and Register My Watch'
    id='checkout.paymentMethod.unauthRegisterCheckbox'
  />
);

export const RegisterMyWatchDescriptionMsg = (isAuthenticated: boolean) => (
  <FormattedMessage
    defaultMessage={
      isAuthenticated
        ? 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.'
        : 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.'
    }
    id={`${intlPrefix}.registerMyWatchDescriptionMsg`}
  />
);
export const RegisterMyWatchAuthDescriptionMessage = () => (
  <FormattedMessage
    defaultMessage='By registering your watch, you ensure that you receive timely updates on maintenance schedules, ensuring your timepiece remains in peak condition for years to come.'
    id='checkout.paymentMethod.registerDescription'
  />
);
export const RegisterMyWatchUnAuthDescriptionMessage = () => (
  <FormattedMessage
    defaultMessage='By registering your watch, you ensure that you receive timely updates on maintenance schedules, ensuring your timepiece remains in peak condition for years to come.'
    id='checkout.paymentMethod.unauthRegisterDescription'
  />
);

export const AccountCreateAndWatchRegisterCheckboxMsg = (
  <FormattedMessage
    defaultMessage='I would like to {createMyAccount} and {registerMyWatch}'
    id={`${intlPrefix}.accountCreateAndWatchRegisterCheckboxMsg`}
    values={{
      createMyAccount: (
        <Text as='span' fontWeight='bold'>
          <FormattedMessage {...formMessages.createMyAccount} />
        </Text>
      ),
      registerMyWatch: (
        <Text as='span' fontWeight='bold'>
          <FormattedMessage {...formMessages.registerMyWatch} />
        </Text>
      ),
    }}
  />
);
export const AccountCreateCheckboxMsg = (
  <FormattedMessage
    defaultMessage='I would like to {createMyAccount}'
    id={`${intlPrefix}.accountCreateCheckboxMsg`}
    values={{
      createMyAccount: (
        <Text as='span' fontWeight='bold'>
          <FormattedMessage {...formMessages.createMyAccount} />
        </Text>
      ),
    }}
  />
);
export const WatchRegisterCheckboxMsg = (
  <FormattedMessage
    defaultMessage='I would like to {registerMyWatch}'
    id={`${intlPrefix}.watchRegisterCheckboxMsg`}
    values={{
      registerMyWatch: (
        <Text as='span' fontWeight='bold'>
          <FormattedMessage {...formMessages.registerMyWatch} />
        </Text>
      ),
    }}
  />
);

export const JoinBreitlingClub = (
  <FormattedMessage
    defaultMessage='I would like to join Breitling Club'
    id={`${intlPrefix}.joinBreitlingClub`}
    values={{
      joinBreitlingClub: (
        <Text as='span' fontWeight='bold'>
          <FormattedMessage {...formMessages.joinBreitlingClub} />
        </Text>
      ),
    }}
  />
);
